'use client';

import { useState } from 'react';
import DrawResults from './DrawResults';
import dayjs from 'dayjs';
import { toast } from 'react-hot-toast';

export default function BetKeypad({
  onNumberPress,
  onDelete,
  onAddBets,
  drawTimes,
  gameSettings,
  onSelectedDrawTime,
  gameType,
  activeDrawTime,
  game,
  isDrawTimeCutoff,
  cutOffTimes,
}) {
  const [selectedType, setSelectedType] = useState('COMBINATION');
  const [type, setType] = useState('PICK3');
  const [numbers, setNumbers] = useState([]);
  const [showInput, setShowInput] = useState(false);
  const [isToggled, setIsToggled] = useState(false);
  const [textBets, setTextBets] = useState('');
  const [bet, setBet] = useState({
    combination: '',
    combination2: '',
    combination3: '',
    straight: '',
    ramble: '',
  });
  const [activeInput, setActiveInput] = useState('combination');
  const [multiplyRamble, setMultiplyRamble] = useState(false);
  const [pressedKey, setPressedKey] = useState(null);

  const keypadConfig = {
    numbers: [
      { key: 1, value: '1', type: 'number' },
      { key: 2, value: '2', type: 'number' },
      { key: 3, value: '3', type: 'number' },
      { key: 4, value: '4', type: 'number' },
      { key: 5, value: '5', type: 'number' },
      { key: 6, value: '6', type: 'number' },
      { key: 7, value: '7', type: 'number' },
      { key: 8, value: '8', type: 'number' },
      { key: 'add', value: 'ADD\nBETS', type: 'action' },
      { key: 9, value: '9', type: 'number' },
      { key: 0, value: '0', type: 'number' },
      { key: 'delete', value: '<', type: 'action' },
    ],
  };

  const combinationLimit = () => {
    switch (gameType) {
      case 'LAST2':
        return 2;
      case '2D':
        return 5;
      case 'S2':
        return 2;
      case 'PICK3':
        return 2;
      case '4D':
        return 4;
      case '6D':
        return 6;
      default:
        return 3;
    }
  };

  const getDisplayTypes = () => {
    if (gameType === 'PICK3') {
      return ['COMBINATION', 'COMBINATION2', 'COMBINATION3', 'STRAIGHT'];
    }
    return ['COMBINATION', 'STRAIGHT', 'RAMBLE'];
  };

  const getDisplayLabel = (type) => {
    if (gameType === 'PICK3') {
      switch (type) {
        case 'COMBINATION':
          return '1ST';
        case 'COMBINATION2':
          return '2ND';
        case 'COMBINATION3':
          return '3RD';
        default:
          return type;
      }
    }
    return type;
  };

  /* Get the max combination for pick3 */
  const pick3MaxCombi = () => {
    const limit = [49, 45, 42, 45, 49, 45, 58];
    return limit[dayjs().day()];
  };

  const handleKeyPress = (keyConfig) => {
    setPressedKey(keyConfig.key);

    setTimeout(() => {
      setPressedKey(null);
    }, 100);

    if (keyConfig.type === 'number') {
      if (activeInput && activeInput.includes('combination')) {
        if (bet[activeInput] && bet[activeInput].length >= combinationLimit()) {
          return;
        }

        setBet((prev) => {
          const newBet = { ...prev };
          if (!newBet[activeInput]) {
            newBet[activeInput] = '';
          }
          if (gameType === '2D' && newBet[activeInput].length === 2) {
            newBet[activeInput] += '-';
          }
          newBet[activeInput] += keyConfig.value;
          return newBet;
        });

        if (gameType === 'PICK3') {
          if (
            activeInput === 'combination' &&
            bet.combination &&
            bet.combination.length === 1
          ) {
            setTimeout(() => {
              setSelectedType('COMBINATION2');
              setActiveInput('combination2');
            }, 100);
          } else if (
            activeInput === 'combination2' &&
            bet.combination2 &&
            bet.combination2.length === 1
          ) {
            setTimeout(() => {
              setSelectedType('COMBINATION3');
              setActiveInput('combination3');
            }, 100);
          } else if (
            activeInput === 'combination3' &&
            bet.combination3 &&
            bet.combination3.length === 1
          ) {
            setTimeout(() => {
              setSelectedType('STRAIGHT');
              setActiveInput('straight');
            }, 100);
          }
        } else if (gameType === '2D') {
          if (
            activeInput === 'combination' &&
            bet.combination &&
            bet.combination.length === 4
          ) {
            setTimeout(() => {
              setSelectedType('STRAIGHT');
              setActiveInput('straight');
            }, 100);
          }
        } else if (gameType === 'S2' || gameType === 'LAST2') {
          if (
            activeInput === 'combination' &&
            bet.combination &&
            bet.combination.length === 1
          ) {
            setTimeout(() => {
              setSelectedType('STRAIGHT');
              setActiveInput('straight');
            }, 100);
          }
        } else {
          if (
            activeInput === 'combination' &&
            bet.combination &&
            bet.combination.length === combinationLimit() - 1
          ) {
            setTimeout(() => {
              setSelectedType('STRAIGHT');
              setActiveInput('straight');
            }, 100);
          }
        }
        return;
      }

      if (activeInput && (!bet[activeInput] || bet[activeInput].length < 3)) {
        setBet((prev) => ({
          ...prev,
          [activeInput]: (prev[activeInput] || '') + keyConfig.value,
        }));
        if (
          activeInput === 'straight' &&
          bet.straight &&
          bet.straight.length === 2
        ) {
          setTimeout(() => {
            setSelectedType('RAMBLE');
            setActiveInput('ramble');
          }, 100);
        }
      }
    } else if (keyConfig.key === 'delete') {
      handleDelete();
    } else if (keyConfig.key === 'add') {
      handleAddBet();
    }
  };

  const handleDelete = () => {
    setBet((prev) => ({
      ...prev,
      [activeInput]: prev[activeInput].slice(0, -1),
    }));

    if (gameType === 'PICK3') {
      if (activeInput === 'combination3' && bet.combination3.length === 1) {
        setSelectedType('COMBINATION2');
        setActiveInput('combination2');
      } else if (
        activeInput === 'combination2' &&
        bet.combination2.length === 1
      ) {
        setSelectedType('COMBINATION');
        setActiveInput('combination');
      }
    } else {
      if (activeInput === 'ramble' && bet.ramble.length === 1) {
        setSelectedType('STRAIGHT');
        setActiveInput('straight');
      } else if (activeInput === 'ramble' && bet.ramble.length === 1) {
        setSelectedType('STRAIGHT');
        setActiveInput('straight');
      } else if (activeInput === 'straight' && bet.straight.length === 1) {
        setSelectedType('COMBINATION');
        setActiveInput('combination');
      }
    }
  };

  const permute = (str) => {
    if (str.length < 2) return [str];
    const permutations = [];
    for (let i = 0; i < str.length; i += 1) {
      const char = str[i];

      // eslint-disable-next-line no-continue
      if (str.indexOf(char) !== i) continue; // Skip this iteration
      const remainingString = str.slice(0, i) + str.slice(i + 1, str.length);
      const subPermutations = permute(remainingString);
      const newPermutations = subPermutations.map(
        (subPermutation) => char + subPermutation
      );
      permutations.push(...newPermutations);
    }
    return permutations;
  };

  const handleAddBet = () => {
    if (
      ['4D', '6D'].includes(gameType) &&
      (bet.straight % 10 !== 0 || bet.ramble % 10 !== 0)
    ) {
      toast.error('Cannot add bet if amount is not divisible by 10', {
        position: 'bottom-center',
        duration: 3000,
      });
      return;
    }
    if (bet.combination.length !== combinationLimit() && gameType !== 'PICK3') {
      toast.error('Invalid Combination', {
        position: 'bottom-center',
        duration: 3000,
      });
      return;
    }

    const combi1 = Number(bet.combination);
    const combi2 = Number(bet.combination2);
    const combi3 = Number(bet.combination3);

    if (gameType === 'PICK3') {
      if (
        [combi1, combi2, combi3].some(
          (combi) => combi > pick3MaxCombi() || combi === 0 || isNaN(combi)
        )
      ) {
        toast.error('Invalid Combination', {
          position: 'bottom-right',
        });
        return;
      }
    }

    if (gameType === '2D') {
      if (bet.combination.includes('-')) {
        const [first, second] = bet.combination.split('-');
        if (first < 1 || first > 31 || second < 1 || second > 31) {
          toast.error('Invalid Combination');
          return;
        }
      }
    }

    if (bet.combination && (bet.straight || bet.ramble)) {
      if ((bet.straight && !+bet.straight) || (bet.ramble && !+bet.ramble)) {
        toast.error('Please enter the amount');
        return;
      }

      // Check for negative amounts
      if (
        (bet.straight && +bet.straight < 0) ||
        (bet.ramble && +bet.ramble < 0)
      ) {
        toast.error('Negative amounts are not allowed');
        return;
      }

      const modifiedBet = { ...bet };

      // Apply multiplication for ramble bets based on the game type
      if (modifiedBet.ramble && multiplyRamble) {
        let rambleAmount = +modifiedBet.ramble;
        if (['Swertres', 'STL', 'LAST3'].includes(gameType)) {
          const combiCount = [...new Set(modifiedBet.combination.split(''))]
            .length;
          if (combiCount === 2) {
            rambleAmount = rambleAmount * 3;
          } else if (combiCount === 3) {
            rambleAmount = rambleAmount * 6;
          }
          modifiedBet.ramble = rambleAmount.toString();
        } else if (['2D', 'LAST2', 'S2'].includes(gameType)) {
          modifiedBet.ramble = (rambleAmount * 2).toString();
        }
      }

      if (modifiedBet.ramble && ['4D', '6D'].includes(gameType)) {
        const permutations = permute(modifiedBet.combination);
        modifiedBet.rambleAmount = modifiedBet.ramble;
        modifiedBet.ramble = (
          modifiedBet.ramble * permutations.length
        ).toString();
      }
      console.log(modifiedBet);
      onAddBets(modifiedBet);
      setBet({ combination: '', straight: '', ramble: '' });
      setActiveInput('combination');
    }
  };

  const handleTextBets = () => {
    if (['4D', '6D'].includes(gameType)) {
      toast.error(
        'Sorry, the Text Field option is currently unavailable for this game. Please use the keypad to place your bets.',
        {
          position: 'bottom-center',
          duration: 3000,
        }
      );
      return;
    }
    let textbetsArray = textBets
      .replaceAll('\n', ',')
      .replaceAll(' ', '')
      .split(',')
      .filter((value) => value !== '');

    if (textbetsArray.length === 0) {
      toast.error('Please enter some bets');
      return;
    }

    let successCount = 0;
    textbetsArray.forEach((data) => {
      const bet = gameType === 'PICK3' ? data.split('/') : data.split('-');

      if (gameType === '2D') {
        bet[0] = bet[0].replace('/', '-');
      }

      if (gameType === 'PICK3') {
        const [combi, combi2, combi3] = bet[0].split('-');
        if (!bet[1] || hasLetter(bet[0])) {
          toast.error(`Invalid bet combination ${bet[0].trim()}`);
          return;
        }
      } else if (
        bet[0].trim().length !== combinationLimit() ||
        !bet[1] ||
        hasLetter(bet[0])
      ) {
        toast.error(`Invalid bet combination ${bet[0].trim()}`);
        return;
      }

      if (gameType === '2D') {
        if (bet[0].includes('-')) {
          const [first, second] = bet[0].split('-');
          if (first < 1 || first > 31 || second < 1 || second > 31) {
            toast.error(`Invalid bet combination ${bet[0].trim()}`);
            return;
          }
        } else {
          toast.error(`Invalid bet combination ${bet[0].trim()}`);
          return;
        }
      }

      const betObj = {
        combination: '',
        combination2: '',
        combination3: '',
        straight: '',
        ramble: '',
      };

      const isRamble = bet[1].toLowerCase().includes('r');
      let amount = bet[1].toLowerCase().replace('r', '');

      // Check for negative amounts
      if (+amount < 0) {
        toast.error(
          `Negative amounts are not allowed: ${bet[0].trim()}-${bet[1]}`
        );
        return;
      }

      if (gameType === 'PICK3') {
        const [combi1, combi2, combi3] = bet[0].split('-');
        betObj.combination = combi1;
        betObj.combination2 = combi2;
        betObj.combination3 = combi3;

        const combinationArray = [
          betObj.combination,
          betObj.combination2,
          betObj.combination3,
        ];
        const uniqueCombination = [...new Set(combinationArray)];
        if (uniqueCombination.length !== combinationArray.length) {
          toast.error('Invalid combination');
          return;
        }
      } else {
        betObj.combination = bet[0];
      }

      // Apply multiplication for ramble bets based on the game type
      if (isRamble && multiplyRamble) {
        if (['Swertres', 'STL', 'LAST3'].includes(gameType)) {
          const combiCount = [...new Set(bet[0].trim().split(''))].length;
          if (combiCount === 2) {
            amount = amount * 3;
          } else if (combiCount === 3) {
            amount = amount * 6;
          }
        } else if (['2D', 'LAST2', 'S2'].includes(gameType)) {
          amount = amount * 2;
        }
      }

      if (isRamble) {
        betObj.ramble = amount;
      } else {
        betObj.straight = amount;
      }

      // Pass skipToast=true to prevent individual toasts
      onAddBets(betObj, true);
      successCount++;
    });

    if (successCount > 0) {
      toast.success(
        `${successCount} bet${successCount > 1 ? 's' : ''} added successfully`
      );
    }

    setTextBets('');
  };

  const hasLetter = (text) => {
    const hasLetterRegex = /[a-zA-Z]/;
    return hasLetterRegex.test(text);
  };

  return (
    <div className='bg-black bg-opacity-50 rounded-lg p-4 max-xs:p-2 border-2 border-yellow-300'>
      <DrawResults
        times={drawTimes}
        gameSettings={gameSettings}
        activeDrawTime={activeDrawTime}
        onSelectedDrawTime={onSelectedDrawTime}
        isDrawTimeCutoff={isDrawTimeCutoff}
        cutOffTimes={cutOffTimes}
      />

      {showInput ? (
        <div className='w-full max-w-md bg-[#1A1A1A] rounded-xl p-.5'>
          <form>
            <div className='mb-1 mt-5'>
              <textarea
                value={textBets}
                onChange={(e) => setTextBets(e.target.value)}
                className='w-full h-52 bg-white text-[#65758B] rounded-xl p-2 text-xs resize-none focus:outline-none focus:ring-2 focus:ring-blue-500'
                placeholder={`Type or paste your comma-separated bets here.\nExample format: ${
                  gameType === 'PICK3'
                    ? '1-2-3/5\n11-22-33/10\n10-20-30/20'
                    : gameType === '2D'
                    ? '01/31-10,01/31-10r'
                    : '123-5,234-5r'
                }`}
              />
            </div>

            <div className='flex items-start gap-4 pl-4'>
              <div className='relative flex items-center'>
                <div
                  className={`w-8 h-4 flex items-center rounded-full p-1 cursor-pointer transition-colors ${
                    multiplyRamble ? 'bg-[#0E64D1]' : 'bg-gray-600'
                  }`}
                  onClick={() => setMultiplyRamble(!multiplyRamble)}
                >
                  <div
                    className={`w-3.5 h-3.5 bg-white rounded-full shadow-md transform transition-transform ${
                      multiplyRamble ? 'translate-x-3' : 'translate-x-0'
                    }`}
                  ></div>
                </div>
              </div>

              <div className='flex items-start flex-col gap-2 mb-4 text-white'>
                <span className='text-xs font-normal leading-none'>
                  Allow the multiplication of ramble bets.
                </span>
                <span className='text-xs font-bold'>
                  {['Swertres', 'STL', 'LAST3'].includes(gameType)
                    ? '123-1r = P6.00 | 122-1r = P3.00'
                    : ['2D', 'LAST2', 'S2'].includes(gameType)
                    ? '12-10r = P20.00'
                    : ''}
                </span>
              </div>
            </div>
          </form>
        </div>
      ) : (
        <>
          {gameType !== 'PICK3' && (
            <div className='grid grid-cols-3 gap-2 max-xs:gap-1 py-2 max-xs:py-1 mt-2 max-xs:mt-1'>
              {getDisplayTypes().map((type) => (
                <div
                  onClick={() => {
                    setSelectedType(type);
                    setActiveInput(type.toLowerCase());
                  }}
                  key={type}
                  className={`relative py-6 rounded-lg ${
                    type === 'STRAIGHT' && gameType === 'PICK3'
                      ? 'col-span-2'
                      : ''
                  }`}
                  style={{
                    background:
                      gameType === 'PICK3'
                        ? 'linear-gradient(360deg, #FFFFFF 0%, #FFFFFF 100%)'
                        : 'linear-gradient(360deg, #FFFFFF 0%, #D4DEEB 100%)',
                  }}
                >
                  <button
                    onClick={() => {
                      setSelectedType(type);
                      setActiveInput(type.toLowerCase());
                    }}
                    className={`absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 p-1.5 text-[10px] font-bold rounded-full border ${
                      selectedType === type
                        ? 'treasure-top border-yellow-200 bg-gradient-to-b from-[#FF0000] via-[#6D1010] to-[#FF0000] text-yellow-200'
                        : 'bg-gradient-to-b from-[#65758B] via-[#12131A] to-[#65758B] text-gray-200'
                    }
                    `}
                  >
                    {getDisplayLabel(type)}
                  </button>
                  <div
                    className={`text-center font-bold text-gray-700 h-6 flex items-center justify-center ${
                      type === 'STRAIGHT' ? 'text-xl' : 'text-lg'
                    }`}
                    onClick={() => {
                      setSelectedType(type);
                      setActiveInput(type.toLowerCase());
                    }}
                  >
                    {bet[type.toLowerCase()] || '\u00A0'}
                  </div>
                </div>
              ))}
            </div>
          )}

          {gameType === 'PICK3' && (
            <div className='grid grid-cols-5 gap-2 max-xs:gap-1 py-2 max-xs:py-1 mt-2 max-xs:mt-1'>
              {getDisplayTypes().map((type) => (
                <div
                  onClick={() => {
                    setSelectedType(type);
                    setActiveInput(type.toLowerCase());
                  }}
                  key={type}
                  className={`relative py-6 rounded-lg ${
                    type === 'STRAIGHT' && gameType === 'PICK3'
                      ? 'col-span-2'
                      : ''
                  }`}
                  style={{
                    background:
                      gameType === 'PICK3'
                        ? 'linear-gradient(360deg, #FFFFFF 0%, #FFFFFF 100%)'
                        : 'linear-gradient(360deg, #FFFFFF 0%, #D4DEEB 100%)',
                  }}
                >
                  <button
                    onClick={() => {
                      setSelectedType(type);
                      setActiveInput(type.toLowerCase());
                    }}
                    className={`absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 p-1.5 text-[10px] font-bold rounded-full ${
                      selectedType === type
                        ? 'bg-gradient-to-b from-[#FF0000] via-[#6D1010] to-[#FF0000] text-yellow-200'
                        : 'bg-gradient-to-b from-[#65758B] via-[#12131A] to-[#65758B] text-gray-200'
                    }`}
                  >
                    {getDisplayLabel(type)}
                  </button>
                  <div
                    className={`text-center font-bold text-gray-700 h-6 flex items-center justify-center ${
                      type === 'STRAIGHT' ? 'text-xl' : 'text-lg'
                    }`}
                    onClick={() => {
                      setSelectedType(type);
                      setActiveInput(type.toLowerCase());
                    }}
                  >
                    {bet[type.toLowerCase()] || '\u00A0'}
                  </div>
                </div>
              ))}
            </div>
          )}

          <div className='grid grid-cols-4 gap-2 mt-5 max-xs:gap-2'>
            {keypadConfig.numbers.map((keyConfig) => (
              <button
                key={keyConfig.key}
                onClick={() => handleKeyPress(keyConfig)}
                className={`aspect-square rounded-full ${
                  keyConfig.key === 'add'
                    ? 'text-[20px] max-xs:text-[16px] leading-none font-bold'
                    : keyConfig.key === 'delete'
                    ? 'text-6xl max-xs:text-5xl'
                    : 'text-4xl max-xs:text-4xl font-bold coin-keys'
                } flex items-center justify-center`}
                style={{
                  color: pressedKey === keyConfig.key ? 'white' : '#6D1010',
                  ...(keyConfig.key === 'add' || keyConfig.key === 'delete'
                    ? {
                        background:
                          'linear-gradient(180deg, #FBD115 0%, #FFF9C9 31%, #FFF9C9 48%, #FFE500 52%, #FC9703 100%)',
                      }
                    : {}),
                  transition: 'background 0.1s, color 0.1s',
                  whiteSpace: keyConfig.key === 'add' ? 'pre-line' : 'normal',
                }}
                data-key={keyConfig.key}
              >
                {keyConfig.key === 'add' ? (
                  <>
                    ADD
                    <br />
                    BETS
                  </>
                ) : (
                  keyConfig.value
                )}
              </button>
            ))}
          </div>
        </>
      )}

      <div className='grid grid-cols-2 gap-2 pt-4 max-xs:pt-2 font-semibold'>
        <button
          className='text-blue-500 py-2 max-xs:py-1.5 rounded-full border border-blue-700 text-sm max-xs:text-xs'
          onClick={() => setShowInput(!showInput)}
        >
          {showInput ? 'Keypads' : 'Text Field'}
        </button>
        <button
          onClick={handleTextBets}
          className={`py-2 max-xs:py-1.5 rounded-full text-sm max-xs:text-xs bg-[#0E64D1] ${
            showInput
              ? 'bg-[#0E64D1] text-white'
              : 'bg-[#34394B] text-[#71758A]'
          } `}
        >
          Add Text Bet
        </button>
      </div>
    </div>
  );
}
